export default __webpack_public_path__ + "d54370a07df790a33e70bfff65e222a5.png";